import { render, staticRenderFns } from "./GalleryModal.vue?vue&type=template&id=3a3944be&"
import script from "./GalleryModal.vue?vue&type=script&lang=js&"
export * from "./GalleryModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a3944be')) {
      api.createRecord('3a3944be', component.options)
    } else {
      api.reload('3a3944be', component.options)
    }
    module.hot.accept("./GalleryModal.vue?vue&type=template&id=3a3944be&", function () {
      api.rerender('3a3944be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/realEstate/modals/GalleryModal.vue"
export default component.exports